import { render } from "./Confirm-Modal.vue?vue&type=template&id=0cff351c"
import script from "./Confirm-Modal.vue?vue&type=script&lang=js"
export * from "./Confirm-Modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__